import Parse from "parse";

Parse.initialize("openinc");
Parse.serverURL = "https://parse-bcm.apps.openinc.dev/parse";
// Parse.serverURL = "http://localhost:1337/parse";
